<div class="shop-filters-wrapper" [class.sticky-to-top]="stickyToTop">
  @if (!sidebar) {
  <div class="filters-heading pl-20-px pr-20-px">
    <h3 class="m-unset">Filters</h3>
    <div class="filters-header-actions">
      <span (click)="clearFilters()" pRipple class="clear-filters"
        >Clear filters</span
      >
      @if (sidebar) {
      <img
        (click)="closeFiltersSidebar()"
        src="./../../../../assets/images/icons/close.svg"
        alt="close-icon"
      />
      }
    </div>
  </div>
  }

  <p-accordion [styleClass]="'filters-accordion'" [multiple]="true">
    @if(smLayout && topFilters && collection){
      <p-accordionTab [selected]="true">
        <ng-template pTemplate="header">
          <div class="accordion-custom-heading">
            <span class="accordion-heading-text">Quick filters</span>
  
            @if(loading$ | async ){
            <p-progressSpinner
              styleClass="c-loader small"
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            ></p-progressSpinner>
  
            } @else {
            <img
              class="expand-icon"
              src="./../../../../assets/images/icons/arrow_drop_down_dark.svg"
              alt="expand"
            />
            }
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <app-quick-filters [collection]="collection" [topFilters]="topFilters"
          [activeQuickFilters]="activeQuickFilters" [loading$]="loading$" [sidebar]="true"></app-quick-filters>
          </ng-template>
          </p-accordionTab>
    }
    <p-accordionTab [selected]="true">
      <ng-template pTemplate="header">
        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">Availability</span>

          @if(loading$ | async ){
          <p-progressSpinner
            styleClass="c-loader small"
            strokeWidth="2"
            fill="var(--surface-ground)"
            animationDuration=".5s"
          ></p-progressSpinner>

          } @else {
          <img
            class="expand-icon"
            src="./../../../../assets/images/icons/arrow_drop_down_dark.svg"
            alt="expand"
          />
          }
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-control
          [disabled]="loading$ | async"
          [classess]="'filter-option-checkbox mb-unset'"
          [control]="onlyAvailableControl"
          [name]="'Only available'"
          [binary]="true"
          [label]="'Show only available'"
          [labelPosition]="'After'"
        ></app-checkbox-control>
      </ng-template>
    </p-accordionTab>
    @for(filter of leftFilters; track filter.id; let index = $index){ @if(true){
    <p-accordionTab [selected]="true">
      <ng-template pTemplate="header">
        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">{{ filter.name }}</span>

          @if(loading$ | async ){
          <p-progressSpinner
            styleClass="c-loader small"
            strokeWidth="2"
            fill="var(--surface-ground)"
            animationDuration=".5s"
          ></p-progressSpinner>

          } @else {
          <img
            class="expand-icon"
            src="./../../../../assets/images/icons/arrow_drop_down_dark.svg"
            alt="expand"
          />
          }
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-options
          [loading$]="loading$"
          [checkboxOptions]="filterOptions[filter.id]"
          [filterId]="filter.id"
          [filterControl]="filterControls.get(filter.id)"
          [name]="filter.name"
          [initialLoading]="initialLoading"
          [searchEnabled]="filterOptions[filter.id]?.length > 10"
        >
        </app-checkbox-options>
      </ng-template>
    </p-accordionTab>
    } } @empty { }
    <!-- NEW FEATURE 
    <app-not-available-overlay>
    <p-accordionTab [selected]="true">
      <ng-template pTemplate="header">
        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">FITTING POSITION</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>

      </ng-template>
      <ng-template pTemplate="content">

          <app-vehicle-position-selection></app-vehicle-position-selection>

      </ng-template>

    </p-accordionTab>
  </app-not-available-overlay>

  <app-not-available-overlay>
    <p-accordionTab [selected]="true">
      <ng-template pTemplate="header">

        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">PRICE</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-price-slider></app-price-slider>
      </ng-template>

    </p-accordionTab>
  </app-not-available-overlay>
-->

    <!--
    <p-accordionTab [selected]="true">
      <ng-template pTemplate="header">

        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">MANUFACTURER</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-options [checkboxOptions]="filters.manufacturers" [searchEnabled]="true"
        [searchControl]="manufacturersSearchControl" [name]="'Manufacturer'"></app-checkbox-options>
      </ng-template>

    </p-accordionTab>

    <p-accordionTab [selected]="true">
      <ng-template pTemplate="header">

        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">INNER DIAMETER</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-options [checkboxOptions]="filters.innerDiameter" [name]="'Inner diameter'">
        </app-checkbox-options>
      </ng-template>

    </p-accordionTab>

    <p-accordionTab [selected]="true">
      <ng-template pTemplate="header">

        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">Outer diameter</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-options [checkboxOptions]="filters.outerDiameter" [name]="'Outer diameter'">
        </app-checkbox-options>
      </ng-template>

    </p-accordionTab>


    <p-accordionTab>
      <ng-template pTemplate="header">

        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">Height</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-options [checkboxOptions]="filters.height" [name]="'Height'"></app-checkbox-options>
      </ng-template>

    </p-accordionTab>



    <p-accordionTab>
      <ng-template pTemplate="header">

        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">Hardness</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-options [checkboxOptions]="filters.hardness" [name]="'Hardness'"></app-checkbox-options>
      </ng-template>

    </p-accordionTab>



    <p-accordionTab>
      <ng-template pTemplate="header">

        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">Material</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-options [checkboxOptions]="filters.material" [name]="'Material'"></app-checkbox-options>
      </ng-template>

    </p-accordionTab>

    <p-accordionTab>
      <ng-template pTemplate="header">

        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">Length</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-options [checkboxOptions]="filters.length" [name]="'Length'"></app-checkbox-options>
      </ng-template>

    </p-accordionTab>

    <p-accordionTab>
      <ng-template pTemplate="header">

        <div class="accordion-custom-heading">
          <span class="accordion-heading-text">Quantity per set</span>
          <img class="expand-icon" src="./../../../../assets/images/icons/arrow_drop_down_dark.svg" alt="expand">
        </div>
      </ng-template>
      <ng-template pTemplate="content">
        <app-checkbox-options [checkboxOptions]="filters.quantityPerSet" [name]="'Quantity per set'">
        </app-checkbox-options>
      </ng-template>

    </p-accordionTab>
  -->
  </p-accordion>
</div>
